import { professionalStatusEntityName } from '../../../../backend/config/classifiers/entities/defineProfessionalStatusClassifier';
import { oigBoardName } from '../../../../backend/constants';
import { functionBodyToString } from '@juvare/common-form-ui/WidgetForm/Utils';
export const hideIfProfessionalStatusTypeIsNotLicensed = functionBodyToString((handler) => {
    var _a, _b, _c;
    const professionalStatuses = handler.formParams.professionalStatuses;
    const professionalStatusWidgetData = (_a = handler.up().down(handler.formParams.professionalStatusCredentialId)) === null || _a === void 0 ? void 0 : _a.getData();
    // Since there can only be one license for the Professional Status credential, it's safe to take the currentProfessionalStatusId from the first license
    const professionalStatusId = (_b = professionalStatusWidgetData === null || professionalStatusWidgetData === void 0 ? void 0 : professionalStatusWidgetData.licenses[0]) === null || _b === void 0 ? void 0 : _b.whatIsYourCurrentProfessionalStatusForThisOccupation;
    return ((_c = professionalStatuses === null || professionalStatuses === void 0 ? void 0 : professionalStatuses.find(({ value }) => value === professionalStatusId)) === null || _c === void 0 ? void 0 : _c.type) !== 'licensed';
}, 'handler');
export const defaultOccupationCredentialData = [
    {
        name: 'Active Clinical Practice',
        status: 'deprecated',
    },
    {
        name: 'Active Hospital Practice',
        status: 'deprecated',
    },
    {
        name: 'Advanced Practice Nurse Specialty',
        status: 'deprecated',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you possess an APN Specialty Certification from an awarding organization (or recognized national organization), provide the relevant information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    key: 'isTheNameOnThisSpecialty',
                    type: 'form.radio',
                    label: 'Is the name on this specialty the same as the name you provided in your personal information',
                    style: {
                        inline: true,
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                    validate: {
                        required: false,
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^isTheNameOnThisSpecialty',
                        dataNotEq: 'No',
                    },
                    children: [
                        {
                            key: 'firstName',
                            type: 'form.text',
                            label: 'First Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'middleName',
                            type: 'form.text',
                            label: 'Middle Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                        },
                        {
                            key: 'lastName',
                            type: 'form.text',
                            label: 'Last Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'suffix',
                            type: 'form.text',
                            label: 'Suffix',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'specialtyCertification',
                            type: 'form.select',
                            label: 'Specialty Certification',
                            valueProvider: {
                                type: 'classifier.aprnSpecialty',
                            },
                        },
                        {
                            key: 'licenseNumber',
                            type: 'form.text',
                            label: 'Certification Number',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'awardingOrganization',
                            type: 'form.text',
                            label: 'Awarding Organization',
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.date',
                            label: 'Expiration Date:',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Adverse Actions',
        status: 'retired',
        form: {
            type: 'form',
            children: [],
        },
    },
    {
        name: 'American Association for Marriage and Family Therapy Exam',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'didYouSuccessfullyComplete',
                    type: 'form.yesNo',
                    label: 'Did you successfully complete the American Association for Marriage and Family Therapy Examination',
                    style: {
                        inline: true,
                    },
                },
            ],
        },
    },
    {
        name: 'American Board of Medical Specialties Certification',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.yesNo',
                    key: 'doYouPossessABoardCertification',
                    label: 'Do you possess ABMS® Member Board Certification?',
                    style: {
                        inline: true,
                    },
                },
                {
                    type: 'form.divider',
                },
                {
                    type: 'form.panel',
                    style: {
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^doYouPossessABoardCertification',
                        dataNotEq: true,
                    },
                    children: [
                        {
                            type: 'form.panel',
                            key: 'abmsMemberBoardCertification',
                            label: 'ABMS® Member Board Certification',
                            style: {
                                horizontalAlign: 'left',
                            },
                            hidden: {
                                when: '^^doYouPossessABoardCertification',
                                dataNotEq: true,
                            },
                            children: [
                                {
                                    type: 'form.content',
                                    key: 'content',
                                    text: 'If you possess a specialty from a licensing board, provide the relevant information',
                                    style: {
                                        alert: 'info',
                                    },
                                },
                                {
                                    type: 'form.radio',
                                    key: 'isTheNameOnThisSpecialty',
                                    label: 'Is the name on this certification the same as the name you provided in your personal information?',
                                    style: {
                                        inline: true,
                                    },
                                    values: [
                                        {
                                            label: 'Yes',
                                            value: 'Yes',
                                        },
                                        {
                                            label: 'No',
                                            value: 'No',
                                        },
                                    ],
                                    validate: {
                                        required: false,
                                    },
                                },
                                {
                                    type: 'form.panel',
                                    style: {
                                        layout: 'row',
                                        horizontalAlign: 'left',
                                    },
                                    hidden: {
                                        when: '^isTheNameOnThisSpecialty',
                                        dataNotEq: 'No',
                                    },
                                    children: [
                                        {
                                            type: 'form.text',
                                            key: 'firstName',
                                            label: 'First Name:',
                                            hidden: {
                                                when: '^radio',
                                                dataNotEq: 'No',
                                            },
                                            validate: {
                                                required: true,
                                            },
                                        },
                                        {
                                            type: 'form.text',
                                            key: 'middleName',
                                            label: 'Middle Name:',
                                            hidden: {
                                                when: '^radio',
                                                dataNotEq: 'No',
                                            },
                                        },
                                        {
                                            type: 'form.text',
                                            key: 'lastName',
                                            label: 'Last Name:',
                                            hidden: {
                                                when: '^radio',
                                                dataNotEq: 'No',
                                            },
                                            validate: {
                                                required: true,
                                            },
                                        },
                                        {
                                            type: 'form.text',
                                            key: 'suffix',
                                            label: 'Suffix',
                                        },
                                    ],
                                },
                                {
                                    type: 'form.panel',
                                    style: {
                                        layout: 'row',
                                        horizontalAlign: 'left',
                                    },
                                    children: [
                                        {
                                            type: 'form.select',
                                            key: 'licenseNumber',
                                            label: 'ABMS Certification',
                                            valueProvider: {
                                                type: 'classifier.abmsCertification',
                                            },
                                        },
                                        {
                                            type: 'form.date',
                                            key: 'expirationDate',
                                            label: 'Expiration Date',
                                            format: 'mm/dd/yyyy',
                                            hidden: {
                                                when: '^noExpirationDate',
                                                dataEq: true,
                                            },
                                        },
                                        {
                                            type: 'form.checkbox',
                                            key: 'noExpirationDate',
                                            label: 'Check this box if your certification has no expiration date',
                                        },
                                    ],
                                },
                            ],
                            clearDataOnHide: true,
                        },
                    ],
                },
                {
                    type: 'form',
                    children: [],
                },
            ],
        },
    },
    {
        name: 'American Board of Nursing Specialty Certification',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you possess a specialty from a licensing board, provide the relevant information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'certifiedSpecialty',
                            type: 'form.select',
                            label: 'Certified Specialty',
                            valueProvider: {
                                type: 'classifier.abnsCertification',
                            },
                        },
                        {
                            key: 'issueDate',
                            type: 'form.date',
                            label: 'Issue Date',
                            format: 'mm/dd/yyyy',
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.date',
                            label: 'Expiration Date',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'American Board of Professional Psychology Certification',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you possess a specialty from a licensing board, provide the relevant information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.panel',
                    children: [
                        {
                            key: 'isTheNameOnThisSpecialty',
                            type: 'form.radio',
                            label: 'Is the name on this specialty the same as the name you provided in your personal information',
                            style: {
                                inline: true,
                            },
                            values: [
                                {
                                    label: 'Yes',
                                    value: 'Yes',
                                },
                                {
                                    label: 'No',
                                    value: 'No',
                                },
                            ],
                            validate: {
                                required: false,
                            },
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            hidden: {
                                when: '^isTheNameOnThisSpecialty',
                                dataNotEq: 'No',
                            },
                            children: [
                                {
                                    key: 'firstName',
                                    type: 'form.text',
                                    label: 'First Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    key: 'middleName',
                                    type: 'form.text',
                                    label: 'Middle Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                },
                                {
                                    key: 'lastName',
                                    type: 'form.text',
                                    label: 'Last Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    key: 'suffix',
                                    type: 'form.text',
                                    label: 'Suffix',
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    key: 'specialty',
                                    type: 'form.select',
                                    label: 'Specialty',
                                    valueProvider: {
                                        type: 'classifier.abppCertification',
                                    },
                                },
                                {
                                    key: 'licenseNumber',
                                    type: 'form.text',
                                    label: 'Certification Number',
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    key: 'awardingOrganization',
                                    type: 'form.text',
                                    label: 'Awarding Organization',
                                },
                                {
                                    key: 'expirationDate',
                                    type: 'form.date',
                                    label: 'Expiration Date:',
                                    format: 'mm/dd/yyyy',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'American Osteopathic Association Certification',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.yesNo',
                    key: 'doYouPossessAoaCertifications',
                    label: 'Do you possess AOA Bureau of Osteopathic Specialists Certification?',
                    style: {
                        inline: true,
                    },
                },
                {
                    type: 'form.divider',
                },
                {
                    type: 'form.panel',
                    style: {
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^doYouPossessABoardCertification',
                        dataNotEq: true,
                    },
                    children: [
                        {
                            type: 'form.panel',
                            key: 'aoaBureauOfOsteopathicSpecialistsCertification',
                            label: 'AOA Bureau of Osteopathic Specialists Certification',
                            style: {
                                horizontalAlign: 'left',
                            },
                            hidden: {
                                when: '^^doYouPossessAoaCertifications',
                                dataNotEq: true,
                            },
                            children: [
                                {
                                    type: 'form.content',
                                    key: 'content',
                                    text: 'If you possess a specialty from a licensing board, provide the relevant information',
                                    style: {
                                        alert: 'info',
                                    },
                                },
                                {
                                    type: 'form.radio',
                                    key: 'isTheNameOnThisSpecialty',
                                    label: 'Is the name on this certification the same as the name you provided in your personal information?',
                                    style: {
                                        inline: true,
                                    },
                                    values: [
                                        {
                                            label: 'Yes',
                                            value: 'Yes',
                                        },
                                        {
                                            label: 'No',
                                            value: 'No',
                                        },
                                    ],
                                    validate: {
                                        required: false,
                                    },
                                },
                                {
                                    type: 'form.panel',
                                    style: {
                                        layout: 'row',
                                        horizontalAlign: 'left',
                                    },
                                    hidden: {
                                        when: '^isTheNameOnThisSpecialty',
                                        dataNotEq: 'No',
                                    },
                                    children: [
                                        {
                                            type: 'form.text',
                                            key: 'firstName',
                                            label: 'First Name:',
                                            hidden: {
                                                when: '^radio',
                                                dataNotEq: 'No',
                                            },
                                            validate: {
                                                required: true,
                                            },
                                        },
                                        {
                                            type: 'form.text',
                                            key: 'middleName',
                                            label: 'Middle Name:',
                                            hidden: {
                                                when: '^radio',
                                                dataNotEq: 'No',
                                            },
                                        },
                                        {
                                            type: 'form.text',
                                            key: 'lastName',
                                            label: 'Last Name:',
                                            hidden: {
                                                when: '^radio',
                                                dataNotEq: 'No',
                                            },
                                            validate: {
                                                required: true,
                                            },
                                        },
                                        {
                                            type: 'form.text',
                                            key: 'suffix',
                                            label: 'Suffix',
                                        },
                                    ],
                                },
                                {
                                    type: 'form.panel',
                                    style: {
                                        layout: 'row',
                                        horizontalAlign: 'left',
                                    },
                                    children: [
                                        {
                                            type: 'form.select',
                                            key: 'licenseNumber',
                                            label: 'AOA Certification',
                                            valueProvider: {
                                                type: 'classifier.aoaCertification',
                                            },
                                        },
                                        {
                                            type: 'form.date',
                                            key: 'expirationDate',
                                            label: 'Expiration Date',
                                            format: 'mm/dd/yyyy',
                                            hidden: {
                                                when: '^noExpirationDate',
                                                dataEq: true,
                                            },
                                        },
                                        {
                                            type: 'form.checkbox',
                                            key: 'noExpirationDate',
                                            label: 'Check this box if your certification has no expiration date',
                                        },
                                    ],
                                },
                            ],
                            clearDataOnHide: true,
                        },
                    ],
                },
                {
                    type: 'form',
                    children: [],
                },
            ],
        },
    },
    {
        name: 'APRN Specialty',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you possess an APN Specialty Certification from an awarding organization (or recognized national organization), provide the relevant information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    key: 'sameNameAsPersonal',
                    type: 'form.radio',
                    label: 'Is the name on this specialty the same as the name you provided in your personal information',
                    style: {
                        inline: true,
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                    validate: {
                        required: false,
                    },
                    defaultValue: 'Yes',
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^sameNameAsPersonal',
                        dataNotEq: 'No',
                    },
                    children: [
                        {
                            key: 'firstName',
                            type: 'form.text',
                            label: 'First Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'middleName',
                            type: 'form.text',
                            label: 'Middle Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                        },
                        {
                            key: 'lastName',
                            type: 'form.text',
                            label: 'Last Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'suffix',
                            type: 'form.text',
                            label: 'Suffix',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'responsive-md',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'specialtyCertification',
                            type: 'form.select',
                            label: 'Specialty Certification',
                            valueProvider: {
                                type: 'classifier.aprnSpecialty',
                            },
                        },
                        {
                            key: 'awardingOrganization',
                            type: 'form.text',
                            label: 'Awarding Organization',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'responsive-md',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'licenseNumber',
                            type: 'form.text',
                            label: 'Certification Number',
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.datePicker',
                            label: 'Expiration Date',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'ASCP Certification Status',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.panel',
                    children: [
                        {
                            key: 'isTheNameOnThisLicenseTheSameAsTheNameYouProvidedInYourPersonalInformation',
                            type: 'form.radio',
                            label: 'Is the name on this license the same as the name you provided in your personal information',
                            style: {
                                inline: true,
                            },
                            values: [
                                {
                                    label: 'Yes',
                                    value: 'Yes',
                                },
                                {
                                    label: 'No',
                                    value: 'No',
                                },
                            ],
                            validate: {
                                required: false,
                            },
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            hidden: {
                                when: '^isTheNameOnThisLicenseTheSameAsTheNameYouProvidedInYourPersonalInformation',
                                dataNotEq: 'No',
                            },
                            children: [
                                {
                                    key: 'firstName',
                                    type: 'form.text',
                                    label: 'First Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    key: 'middleName',
                                    type: 'form.text',
                                    label: 'Middle Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                },
                                {
                                    key: 'lastName',
                                    type: 'form.text',
                                    label: 'Last Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    key: 'suffix',
                                    type: 'form.text',
                                    label: 'Suffix',
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    key: 'ascpCertificationSpecialty',
                                    type: 'form.select',
                                    label: 'ASCP Certification Specialty',
                                    valueProvider: {
                                        type: 'classifier.ascpSpecialty',
                                    },
                                },
                                {
                                    key: 'licenseNumber',
                                    type: 'form.text',
                                    label: 'ASCP Certification Number',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Board Certification',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.yesNo',
                    key: 'doYouPossessABoardCertification',
                    label: 'Do you possess a board certification?',
                    style: {
                        inline: true,
                    },
                },
                {
                    type: 'form.select',
                    key: 'whatTypeSOfCertificationsDoYouPossess',
                    label: 'What type(s) of certifications do you possess?',
                    hidden: {
                        when: '^doYouPossessABoardCertification',
                        dataNotEq: true,
                    },
                    values: [
                        {
                            label: 'ABMS® Member Board Certification',
                            value: 'abms',
                        },
                        {
                            label: 'AOA Bureau of Osteopathic Specialists Certification',
                            value: 'aoa',
                        },
                        {
                            label: 'ABMS® & AOA Certifications',
                            value: 'abmsAndAoa',
                        },
                    ],
                },
                {
                    type: 'form.divider',
                },
                {
                    type: 'form.panel',
                    style: {
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^doYouPossessABoardCertification',
                        dataNotEq: true,
                    },
                    children: [
                        {
                            type: 'form.panel',
                            key: 'abmsMemberBoardCertification',
                            label: 'ABMS® Member Board Certification',
                            style: {
                                horizontalAlign: 'left',
                            },
                            hidden: {
                                when: '^^whatTypeSOfCertificationsDoYouPossess',
                                dataNotIn: ['abms', 'abmsAndAoa'],
                            },
                            children: [
                                {
                                    type: 'form.content',
                                    key: 'content',
                                    text: 'If you possess a specialty from a licensing board, provide the relevant information',
                                    style: {
                                        alert: 'info',
                                    },
                                },
                                {
                                    type: 'form.radio',
                                    key: 'isTheNameOnThisSpecialty',
                                    label: 'Is the name on this certification the same as the name you provided in your personal information?',
                                    style: {
                                        inline: true,
                                    },
                                    values: [
                                        {
                                            label: 'Yes',
                                            value: 'Yes',
                                        },
                                        {
                                            label: 'No',
                                            value: 'No',
                                        },
                                    ],
                                    validate: {
                                        required: false,
                                    },
                                },
                                {
                                    type: 'form.panel',
                                    style: {
                                        layout: 'row',
                                        horizontalAlign: 'left',
                                    },
                                    hidden: {
                                        when: '^isTheNameOnThisSpecialty',
                                        dataNotEq: 'No',
                                    },
                                    children: [
                                        {
                                            type: 'form.text',
                                            key: 'firstName',
                                            label: 'First Name:',
                                            hidden: {
                                                when: '^radio',
                                                dataNotEq: 'No',
                                            },
                                            validate: {
                                                required: true,
                                            },
                                        },
                                        {
                                            type: 'form.text',
                                            key: 'middleName',
                                            label: 'Middle Name:',
                                            hidden: {
                                                when: '^radio',
                                                dataNotEq: 'No',
                                            },
                                        },
                                        {
                                            type: 'form.text',
                                            key: 'lastName',
                                            label: 'Last Name:',
                                            hidden: {
                                                when: '^radio',
                                                dataNotEq: 'No',
                                            },
                                            validate: {
                                                required: true,
                                            },
                                        },
                                        {
                                            type: 'form.text',
                                            key: 'suffix',
                                            label: 'Suffix',
                                        },
                                    ],
                                },
                                {
                                    type: 'form.panel',
                                    style: {
                                        layout: 'row',
                                        horizontalAlign: 'left',
                                    },
                                    children: [
                                        {
                                            type: 'form.select',
                                            key: 'licenseNumber',
                                            label: 'ABMS Certification',
                                            valueProvider: {
                                                type: 'classifier.abmsCertification',
                                            },
                                        },
                                        {
                                            type: 'form.date',
                                            key: 'expirationDate',
                                            label: 'Expiration Date',
                                            format: 'mm/dd/yyyy',
                                            hidden: {
                                                when: '^noExpirationDate',
                                                dataEq: true,
                                            },
                                        },
                                        {
                                            type: 'form.checkbox',
                                            key: 'noExpirationDate',
                                            label: 'Check this box if your certification has no expiration date',
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            key: 'aoaBureauOfOsteopathicSpecialistsCertification',
                            label: 'AOA Bureau of Osteopathic Specialists Certification',
                            style: {
                                horizontalAlign: 'left',
                            },
                            hidden: {
                                when: '^^whatTypeSOfCertificationsDoYouPossess',
                                dataNotIn: ['aoa', 'abmsAndAoa'],
                            },
                            children: [
                                {
                                    type: 'form.content',
                                    key: 'content',
                                    text: 'If you possess a specialty from a licensing board, provide the relevant information',
                                    style: {
                                        alert: 'info',
                                    },
                                },
                                {
                                    type: 'form.radio',
                                    key: 'isTheNameOnThisSpecialty',
                                    label: 'Is the name on this certification the same as the name you provided in your personal information?',
                                    style: {
                                        inline: true,
                                    },
                                    values: [
                                        {
                                            label: 'Yes',
                                            value: 'Yes',
                                        },
                                        {
                                            label: 'No',
                                            value: 'No',
                                        },
                                    ],
                                    validate: {
                                        required: false,
                                    },
                                },
                                {
                                    type: 'form.panel',
                                    style: {
                                        layout: 'row',
                                        horizontalAlign: 'left',
                                    },
                                    hidden: {
                                        when: '^isTheNameOnThisSpecialty',
                                        dataNotEq: 'No',
                                    },
                                    children: [
                                        {
                                            type: 'form.text',
                                            key: 'firstName',
                                            label: 'First Name:',
                                            hidden: {
                                                when: '^radio',
                                                dataNotEq: 'No',
                                            },
                                            validate: {
                                                required: true,
                                            },
                                        },
                                        {
                                            type: 'form.text',
                                            key: 'middleName',
                                            label: 'Middle Name:',
                                            hidden: {
                                                when: '^radio',
                                                dataNotEq: 'No',
                                            },
                                        },
                                        {
                                            type: 'form.text',
                                            key: 'lastName',
                                            label: 'Last Name:',
                                            hidden: {
                                                when: '^radio',
                                                dataNotEq: 'No',
                                            },
                                            validate: {
                                                required: true,
                                            },
                                        },
                                        {
                                            type: 'form.text',
                                            key: 'suffix',
                                            label: 'Suffix',
                                        },
                                    ],
                                },
                                {
                                    type: 'form.panel',
                                    style: {
                                        layout: 'row',
                                        horizontalAlign: 'left',
                                    },
                                    children: [
                                        {
                                            type: 'form.select',
                                            key: 'licenseNumber',
                                            label: 'AOA Certification',
                                            valueProvider: {
                                                type: 'classifier.aoaCertification',
                                            },
                                        },
                                        {
                                            type: 'form.date',
                                            key: 'expirationDate',
                                            label: 'Expiration Date',
                                            format: 'mm/dd/yyyy',
                                            hidden: {
                                                when: '^noExpirationDate',
                                                dataEq: true,
                                            },
                                        },
                                        {
                                            type: 'form.checkbox',
                                            key: 'noExpirationDate',
                                            label: 'Check this box if your certification has no expiration date',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Board of Pharmaceutical Specialty',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'boardOfPharmaceuticalSpecialties',
                    type: 'form.multiSelect',
                    label: 'Board of Pharmaceutical Specialties',
                    description: 'Select all that apply',
                    valueProvider: {
                        type: 'classifier.boardOfPharmaceuticalSpecialty',
                    },
                },
            ],
        },
    },
    {
        name: 'Cardiovascular Technologist / Technician Specialty',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you possess a specialty from a licensing board, provide the relevant information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.panel',
                    children: [
                        {
                            key: 'isTheNameOnThisSpecialty',
                            type: 'form.radio',
                            label: 'Is the name on this specialty the same as the name you provided in your personal information',
                            style: {
                                inline: true,
                            },
                            values: [
                                {
                                    label: 'Yes',
                                    value: 'Yes',
                                },
                                {
                                    label: 'No',
                                    value: 'No',
                                },
                            ],
                            validate: {
                                required: false,
                            },
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            hidden: {
                                when: '^isTheNameOnThisSpecialty',
                                dataNotEq: 'No',
                            },
                            children: [
                                {
                                    key: 'firstName',
                                    type: 'form.text',
                                    label: 'First Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    key: 'middleName',
                                    type: 'form.text',
                                    label: 'Middle Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                },
                                {
                                    key: 'lastName',
                                    type: 'form.text',
                                    label: 'Last Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    key: 'suffix',
                                    type: 'form.text',
                                    label: 'Suffix',
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    key: 'specialty',
                                    type: 'form.select',
                                    label: 'Specialty',
                                    valueProvider: {
                                        type: 'classifier.cardiovascularSpecialty',
                                    },
                                },
                                {
                                    key: 'licenseNumber',
                                    type: 'form.text',
                                    label: 'Certification Number',
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    key: 'awardingOrganization',
                                    type: 'form.text',
                                    label: 'Awarding Organization',
                                },
                                {
                                    key: 'expirationDate',
                                    type: 'form.date',
                                    label: 'Expiration Date:',
                                    format: 'mm/dd/yyyy',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Clinical Experience',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you have clinical experience, indicate it below.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'clinicalSetting',
                            type: 'form.select',
                            label: 'Clinical Setting',
                            values: [
                                {
                                    label: 'Clinic',
                                    value: 'clinic',
                                },
                                {
                                    label: 'Hospital',
                                    value: 'hospital',
                                },
                                {
                                    label: 'Private / Group Practice',
                                    value: 'private',
                                },
                                {
                                    label: 'Public Health',
                                    value: 'public',
                                },
                            ],
                        },
                        {
                            key: 'organizationState',
                            type: 'form.select',
                            label: 'Organization State',
                            valueProvider: {
                                type: 'classifier.state',
                            },
                        },
                        {
                            key: 'organizationCity',
                            type: 'form.text',
                            label: 'Organization City',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'organizationName',
                            type: 'form.text',
                            label: 'Organization Name',
                        },
                        {
                            key: 'supervisorName',
                            type: 'form.text',
                            label: 'Supervisor Name',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'startDate',
                            type: 'form.date',
                            label: 'Start Date',
                            format: 'mm/dd/yyyy',
                        },
                        {
                            key: 'endDate',
                            type: 'form.date',
                            label: 'End Date',
                            format: 'mm/dd/yyyy',
                            hidden: {
                                when: '^noExpirationDate',
                                dataEq: true,
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Degree Information',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.content',
                    key: 'content',
                    text: 'Provide information on your professional education, and degree earned. List the most relevant degree first.',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            type: 'form.text',
                            key: 'degreeInformationDegreeType',
                            label: 'Degree Type',
                            includeWhiteSpace: false,
                        },
                        {
                            type: 'form.date',
                            key: 'Grad_date',
                            label: 'Graduation Date',
                            format: 'mm/dd/yyyy',
                            validate: {
                                required: false,
                            },
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            type: 'form.text',
                            key: 'institutionName',
                            label: 'Institution Name',
                            description: 'Name of the institution that conferred your degree.',
                        },
                        {
                            type: 'form.select',
                            key: 'inst_state',
                            label: 'Institution State',
                            valueProvider: {
                                type: 'classifier.state',
                            },
                        },
                        {
                            type: 'form.text',
                            key: 'city',
                            label: 'Institution City',
                        },
                    ],
                },
                {
                    type: 'form.file',
                    key: 'uploadCertificates',
                    label: 'Upload Certificates',
                    acceptTypes: 'image/png, application/pdf, image/jpeg, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    multipleFiles: true,
                },
            ],
        },
    },
    {
        name: 'Degree Information with Specialization',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.content',
                    key: 'content',
                    text: 'Provide information on your professional education, and degree earned. List the most relevant degree first.',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            type: 'form.text',
                            key: 'degreeInformationWithSpecializationDegreeType',
                            label: 'Degree Type',
                            includeWhiteSpace: false,
                        },
                        {
                            type: 'form.text',
                            key: 'specialization',
                            label: 'Specialization',
                        },
                        {
                            type: 'form.date',
                            key: 'conferredDate',
                            label: 'Conferred Date',
                            format: 'mm/dd/yyyy',
                            validate: {
                                required: false,
                            },
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            type: 'form.text',
                            key: 'institutionName',
                            label: 'Institution Name',
                            description: 'Name of the institution that conferred your degree.',
                        },
                        {
                            type: 'form.select',
                            key: 'institutionState',
                            label: 'Institution State',
                            valueProvider: {
                                type: 'classifier.state',
                            },
                        },
                        {
                            type: 'form.text',
                            key: 'institutionCity',
                            label: 'Institution City',
                        },
                    ],
                },
                {
                    type: 'form.file',
                    key: 'uploadCertificates',
                    label: 'Upload Certificates',
                    acceptTypes: 'image/png, application/pdf, image/jpeg, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    multipleFiles: true,
                },
            ],
        },
    },
    {
        name: 'Dental Specialty',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you possess a specialty from a licensing board, provide the relevant information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    key: 'isTheNameOnThisSpecialty',
                    type: 'form.radio',
                    label: 'Is the name on this specialty the same as the name you provided in your personal information',
                    style: {
                        inline: true,
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                    validate: {
                        required: false,
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^isTheNameOnThisSpecialty',
                        dataNotEq: 'No',
                    },
                    children: [
                        {
                            key: 'firstName',
                            type: 'form.text',
                            label: 'First Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'middleName',
                            type: 'form.text',
                            label: 'Middle Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                        },
                        {
                            key: 'lastName',
                            type: 'form.text',
                            label: 'Last Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'suffix',
                            type: 'form.text',
                            label: 'Suffix',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'specialty',
                            type: 'form.select',
                            label: 'Specialty',
                            valueProvider: {
                                type: 'classifier.dentalSpecialty',
                            },
                        },
                        {
                            key: 'licenseNumber',
                            type: 'form.text',
                            label: 'Certification Number',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'awardingOrganization',
                            type: 'form.text',
                            label: 'Awarding Organization',
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.date',
                            label: 'Expiration Date:',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Diagnostic Medical Sonographer Certification',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you possess a specialty from a licensing board, provide the relevant information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    key: 'isTheNameOnThisSpecialty',
                    type: 'form.radio',
                    label: 'Is the name on this specialty the same as the name you provided in your personal information',
                    style: {
                        inline: true,
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                    validate: {
                        required: false,
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^isTheNameOnThisSpecialty',
                        dataNotEq: 'No',
                    },
                    children: [
                        {
                            key: 'firstName',
                            type: 'form.text',
                            label: 'First Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'middleName',
                            type: 'form.text',
                            label: 'Middle Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                        },
                        {
                            key: 'lastName',
                            type: 'form.text',
                            label: 'Last Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'suffix',
                            type: 'form.text',
                            label: 'Suffix',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'certifyingInstitution',
                            type: 'form.select',
                            label: 'Certifying Institution',
                            values: [
                                {
                                    label: 'American Registry of Diagnostic Medical Sonographers',
                                    value: 'sonographer',
                                },
                                {
                                    label: 'American Registry of Radiologic Technologists',
                                    value: 'radiologicTechnologist',
                                },
                            ],
                        },
                        {
                            key: 'licenseNumber',
                            type: 'form.text',
                            label: 'Certification Number',
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.date',
                            label: 'Expiration Date:',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Drug Enforcement Agency Registration',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'Provide information on your registration with the Drug Enforcement Agency.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    key: 'currentlyPossess',
                    type: 'form.radio',
                    label: 'Do you currently possess a DEA registration:',
                    style: {
                        inline: true,
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^currentlyPossess',
                        dataNotEq: 'Yes',
                    },
                    children: [
                        {
                            key: 'nameTheSame',
                            type: 'form.radio',
                            label: 'Is the name on this license the same as the name you provided in your personal information:',
                            style: {
                                inline: true,
                            },
                            values: [
                                {
                                    label: 'Yes',
                                    value: 'Yes',
                                },
                                {
                                    label: 'No',
                                    value: 'No',
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            hidden: {
                                when: '^nameTheSame',
                                dataNotEq: 'No',
                            },
                            children: [
                                {
                                    key: 'firstName',
                                    type: 'form.text',
                                    label: 'First Name:',
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    key: 'middleName',
                                    type: 'form.text',
                                    label: 'Middle Name:',
                                    validate: {
                                        required: false,
                                    },
                                },
                                {
                                    key: 'lastName',
                                    type: 'form.text',
                                    label: 'Last Name:',
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    key: 'suffix',
                                    type: 'form.text',
                                    label: 'Suffix',
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    key: 'licenseNumber',
                                    type: 'form.text',
                                    label: 'Registration Number:',
                                    description: 'DEA registration number, exactly as it appears on the registration.',
                                },
                                {
                                    key: 'expirationDate',
                                    type: 'form.date',
                                    label: 'Expiration Date:',
                                    format: 'mm/dd/yyyy',
                                },
                            ],
                        },
                        {
                            key: 'federal',
                            type: 'form.radio',
                            label: 'Have you ever involuntarily surrendered or had a federal controlled substance registration revoked, suspended, restricted, or denied:',
                            style: {
                                inline: true,
                            },
                            values: [
                                {
                                    label: 'Yes',
                                    value: 'Yes',
                                },
                                {
                                    label: 'No',
                                    value: 'No',
                                },
                            ],
                        },
                        {
                            key: 'content1',
                            html: '<hr>',
                            type: 'form.content',
                            style: {},
                        },
                    ],
                },
                {
                    key: 'additionalDeaRegistration',
                    type: 'form.dataGrid',
                    label: 'Additional DEA Registration',
                    hidden: {
                        when: '^currentlyPossess',
                        dataNotEq: 'Yes',
                    },
                    children: [
                        {
                            type: 'form.panel',
                            style: {
                                horizontalAlign: 'left',
                            },
                            hidden: {
                                when: '^currentlyPossess',
                                dataNotEq: 'Yes',
                            },
                            children: [
                                {
                                    key: 'nameTheSame',
                                    type: 'form.radio',
                                    label: 'Is the name on this license the same as the name you provided in your personal information:',
                                    style: {
                                        inline: true,
                                    },
                                    values: [
                                        {
                                            label: 'Yes',
                                            value: 'Yes',
                                        },
                                        {
                                            label: 'No',
                                            value: 'No',
                                        },
                                    ],
                                },
                                {
                                    type: 'form.panel',
                                    style: {
                                        layout: 'row',
                                        horizontalAlign: 'left',
                                    },
                                    hidden: {
                                        when: '^nameTheSame',
                                        dataNotEq: 'No',
                                    },
                                    children: [
                                        {
                                            key: 'firstName',
                                            type: 'form.text',
                                            label: 'First Name:',
                                            validate: {
                                                required: true,
                                            },
                                        },
                                        {
                                            key: 'middleName',
                                            type: 'form.text',
                                            label: 'Middle Name:',
                                            validate: {
                                                required: false,
                                            },
                                        },
                                        {
                                            key: 'lastName',
                                            type: 'form.text',
                                            label: 'Last Name:',
                                            validate: {
                                                required: true,
                                            },
                                        },
                                        {
                                            key: 'suffix',
                                            type: 'form.text',
                                            label: 'Suffix',
                                        },
                                    ],
                                },
                                {
                                    type: 'form.panel',
                                    style: {
                                        layout: 'row',
                                        horizontalAlign: 'left',
                                    },
                                    children: [
                                        {
                                            key: 'licenseNumber',
                                            type: 'form.text',
                                            label: 'Registration Number:',
                                            description: 'DEA registration number, exactly as it appears on the registration.',
                                        },
                                        {
                                            key: 'expirationDate',
                                            type: 'form.date',
                                            label: 'Expiration Date:',
                                            format: 'mm/dd/yyyy',
                                        },
                                    ],
                                },
                                {
                                    key: 'federal',
                                    type: 'form.radio',
                                    label: 'Have you ever involuntarily surrendered or had a federal controlled substance registration revoked, suspended, restricted, or denied:',
                                    style: {
                                        inline: true,
                                    },
                                    values: [
                                        {
                                            label: 'Yes',
                                            value: 'Yes',
                                        },
                                        {
                                            label: 'No',
                                            value: 'No',
                                        },
                                    ],
                                },
                                {
                                    key: 'content1',
                                    html: '<hr>',
                                    type: 'form.content',
                                    style: {},
                                },
                            ],
                        },
                    ],
                    addButtonLabel: 'Add Additional DEA Registration',
                },
            ],
        },
    },
    {
        name: 'Professional Status',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.panel',
                    children: [
                        {
                            type: 'form.content',
                            key: 'content',
                            text: 'What is your current professional status for this occupation?',
                            style: {
                                alert: 'info',
                            },
                        },
                        {
                            type: 'form.select',
                            key: 'whatIsYourCurrentProfessionalStatusForThisOccupation',
                            label: 'Current professional status',
                            valueProvider: {
                                type: `classifier.${professionalStatusEntityName}`,
                                paramsFunction: functionBodyToString((handler) => {
                                    var _a, _b;
                                    const professionalStatusForm = handler.upByType('form');
                                    return (_b = (_a = professionalStatusForm === null || professionalStatusForm === void 0 ? void 0 : professionalStatusForm.upByType('form.modalRowList')) === null || _a === void 0 ? void 0 : _a.getData()) === null || _b === void 0 ? void 0 : _b.groupId;
                                }, 'handler'),
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Emergency Medical Endorsements',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.panel',
                    children: [
                        {
                            type: 'form.content',
                            key: 'content',
                            text: 'If you have any endorsements, please select them below:',
                            style: {
                                alert: 'info',
                            },
                        },
                        {
                            type: 'form.multiSelect',
                            key: 'emergencyMedicalEndorsements',
                            label: 'Emergency Medical Endorsements',
                            values: [
                                {
                                    label: 'AEMT - I-99 Endorsement',
                                    value: 'aemtI99Endorsement',
                                },
                                {
                                    label: 'EMT - Airway Endorsement',
                                    value: 'emtAirwayEndorsement',
                                },
                                {
                                    label: 'EMT - IV/IO Initiation Endorsement',
                                    value: 'emtIvIoInitiationEndorsement',
                                },
                                {
                                    label: 'EMT - IV/IO Maintenance Endorsement',
                                    value: 'emtIvIoMaintenanceEndorsement',
                                },
                                {
                                    label: 'EMT - Medication Endorsement',
                                    value: 'emtMedicationEndorsement',
                                },
                                {
                                    label: 'Critical Care Paramedic Endorsement',
                                    value: 'criticalCareParamedicEndorsement',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Experience Specialty',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you have gained a specialty through working experience, indicate it below.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'text_descr',
                            type: 'form.text',
                            label: 'Describe your area of specialty:',
                        },
                        {
                            key: 'yearsOfSpecialtyExperience',
                            type: 'form.number',
                            label: 'Years of specialty experience:',
                            validate: {
                                max: 50,
                                min: 1,
                                required: false,
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'FSMB Clearance Status',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'clearanceStatus',
                    type: 'form.select',
                    label: 'Clearance Status',
                    values: [
                        {
                            label: 'Unknown',
                            value: 'unknown',
                        },
                        {
                            label: 'Clear',
                            value: 'clear',
                        },
                        {
                            label: 'Revoked',
                            value: 'revoked',
                        },
                        {
                            label: 'Suspended',
                            value: 'suspended',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'General Certification',
        status: 'retired',
    },
    {
        name: 'HAM Radio Operator License',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'Please provide your license information. If you are licensed in the state in which you live, please enter that license first.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'responsive-md',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'callSign',
                            type: 'form.text',
                            label: 'Call Sign',
                            description: 'Call Sign, exactly as it appears on the license.',
                        },
                        {
                            key: 'operatorClass',
                            type: 'form.select',
                            label: 'Operator Class',
                            values: [
                                {
                                    label: 'Advanced',
                                    value: 'advanced',
                                },
                                {
                                    label: 'Amateur Extra',
                                    value: 'amateur',
                                },
                                {
                                    label: 'General',
                                    value: 'general',
                                },
                                {
                                    label: 'Novice',
                                    value: 'novice',
                                },
                                {
                                    label: 'Technician',
                                    value: 'technician',
                                },
                                {
                                    label: 'Technician Plus',
                                    value: 'technicianPlus',
                                },
                            ],
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.datePicker',
                            label: 'Expiration Date',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Hospital Affiliation',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'areYouAffiliatedWithAHospital',
                    type: 'form.yesNo',
                    label: 'Are you affiliated with a hospital:',
                    style: {
                        inline: true,
                    },
                },
            ],
        },
    },
    {
        name: 'Injection Administration',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'doYouFeelComfortable',
                    type: 'form.yesNo',
                    label: 'Do you feel comfortable administering an injection pursuant to a written order by a provider',
                    style: {
                        inline: true,
                    },
                },
            ],
        },
    },
    {
        name: 'International Medical Graduate',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you graduated from an International Medical Program, please provide the following information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'licenseNumber',
                            type: 'form.text',
                            label: 'Graduates Number',
                            description: 'ECFMG number, exactly as it appears on your certificate.',
                        },
                        {
                            key: 'issueDate',
                            type: 'form.date',
                            label: 'Issue Date',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Laboratory Technician Specialty',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you possess a specialty from a licensing board, provide the relevant information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    key: 'isTheNameOnThisSpecialty',
                    type: 'form.radio',
                    label: 'Is the name on this specialty the same as the name you provided in your personal information',
                    style: {
                        inline: true,
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                    validate: {
                        required: false,
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^isTheNameOnThisSpecialty',
                        dataNotEq: 'No',
                    },
                    children: [
                        {
                            key: 'firstName',
                            type: 'form.text',
                            label: 'First Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'middleName',
                            type: 'form.text',
                            label: 'Middle Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                        },
                        {
                            key: 'lastName',
                            type: 'form.text',
                            label: 'Last Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'suffix',
                            type: 'form.text',
                            label: 'Suffix',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'specialty',
                            type: 'form.select',
                            label: 'Specialty',
                            valueProvider: {
                                type: 'classifier.laboratoryTechnicianSpecialty',
                            },
                        },
                        {
                            key: 'licenseNumber',
                            type: 'form.text',
                            label: 'Certification Number',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'awardingOrganization',
                            type: 'form.text',
                            label: 'Awarding Organization',
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.date',
                            label: 'Expiration Date:',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Laboratory Technologist Specialty',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you possess a specialty from a licensing board, provide the relevant information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    key: 'isTheNameOnThisSpecialty',
                    type: 'form.radio',
                    label: 'Is the name on this specialty the same as the name you provided in your personal information',
                    style: {
                        inline: true,
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                    validate: {
                        required: false,
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^isTheNameOnThisSpecialty',
                        dataNotEq: 'No',
                    },
                    children: [
                        {
                            key: 'firstName',
                            type: 'form.text',
                            label: 'First Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'middleName',
                            type: 'form.text',
                            label: 'Middle Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                        },
                        {
                            key: 'lastName',
                            type: 'form.text',
                            label: 'Last Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'suffix',
                            type: 'form.text',
                            label: 'Suffix',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'specialty',
                            type: 'form.select',
                            label: 'Specialty',
                            valueProvider: {
                                type: 'classifier.laboratoryTechnologistSpecial',
                            },
                        },
                        {
                            key: 'licenseNumber',
                            type: 'form.text',
                            label: 'Certification Number',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'awardingOrganization',
                            type: 'form.text',
                            label: 'Awarding Organization',
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.date',
                            label: 'Expiration Date:',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Medical Records and Health Information Technologist Specialty',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you possess a specialty from a licensing board, provide the relevant information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    key: 'isTheNameOnThisSpecialty',
                    type: 'form.radio',
                    label: 'Is the name on this specialty the same as the name you provided in your personal information',
                    style: {
                        inline: true,
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                    validate: {
                        required: false,
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^isTheNameOnThisSpecialty',
                        dataNotEq: 'No',
                    },
                    children: [
                        {
                            key: 'firstName',
                            type: 'form.text',
                            label: 'First Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'middleName',
                            type: 'form.text',
                            label: 'Middle Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                        },
                        {
                            key: 'lastName',
                            type: 'form.text',
                            label: 'Last Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'suffix',
                            type: 'form.text',
                            label: 'Suffix',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'specialty',
                            type: 'form.select',
                            label: 'Specialty',
                            valueProvider: {
                                type: 'classifier.medicalRecordsItSpecialty',
                            },
                        },
                        {
                            key: 'licenseNumber',
                            type: 'form.text',
                            label: 'Certification Number',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'awardingOrganization',
                            type: 'form.text',
                            label: 'Awarding Organization',
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.date',
                            label: 'Expiration Date:',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Medical Residency Information',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'Provide information on your medical residency.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'organizationState',
                            type: 'form.select',
                            label: 'Organization State',
                            valueProvider: {
                                type: 'classifier.state',
                            },
                        },
                        {
                            key: 'organizationCity',
                            type: 'form.text',
                            label: 'Organization City',
                        },
                        {
                            key: 'organizationName',
                            type: 'form.text',
                            label: 'Organization Name',
                            description: 'Organization where you completed your residency.',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'residencyDirector',
                            type: 'form.text',
                            label: 'Residency Director',
                            description: 'Name of the director of your residency.',
                        },
                        {
                            key: 'specialty',
                            type: 'form.text',
                            label: 'Specialty',
                        },
                        {
                            key: 'completionDate',
                            type: 'form.date',
                            label: 'Completion Date',
                            format: 'mm/dd/yyyy',
                            hidden: {
                                when: '^noExpirationDate',
                                dataEq: true,
                            },
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'MHC Specialty',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you possess a specialty from a licensing board, provide the relevant information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    key: 'isTheNameOnThisSpecialty',
                    type: 'form.radio',
                    label: 'Is the name on this specialty the same as the name you provided in your personal information',
                    style: {
                        inline: true,
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                    validate: {
                        required: false,
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^isTheNameOnThisSpecialty',
                        dataNotEq: 'No',
                    },
                    children: [
                        {
                            key: 'firstName',
                            type: 'form.text',
                            label: 'First Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'middleName',
                            type: 'form.text',
                            label: 'Middle Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                        },
                        {
                            key: 'lastName',
                            type: 'form.text',
                            label: 'Last Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'suffix',
                            type: 'form.text',
                            label: 'Suffix',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'specialty',
                            type: 'form.select',
                            label: 'Specialty',
                            valueProvider: {
                                type: 'classifier.mhcSpecialty',
                            },
                        },
                        {
                            key: 'licenseNumber',
                            type: 'form.text',
                            label: 'Certification Number',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'awardingOrganization',
                            type: 'form.text',
                            label: 'Awarding Organization',
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.date',
                            label: 'Expiration Date:',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'National Association of Social Workers Certification',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you are certified by the National Association of Social Workers, please provide the following information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    key: 'sameNameAsPersonal',
                    type: 'form.radio',
                    label: 'Is the name on this specialty the same as the name you provided in your personal information',
                    style: {
                        inline: true,
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                    validate: {
                        required: false,
                    },
                    defaultValue: 'Yes',
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'responsive-md',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^sameNameAsPersonal',
                        dataNotEq: 'No',
                    },
                    children: [
                        {
                            key: 'firstName',
                            type: 'form.text',
                            label: 'First Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'middleName',
                            type: 'form.text',
                            label: 'Middle Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                        },
                        {
                            key: 'lastName',
                            type: 'form.text',
                            label: 'Last Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'suffix',
                            type: 'form.text',
                            label: 'Suffix',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'responsive-md',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'specialtyName',
                            type: 'form.select',
                            label: 'Specialty Name',
                            values: [
                                {
                                    label: 'Certified Advanced Children, Youth, and Family Social Worker',
                                    value: 'certifiedAdvancedChildren',
                                },
                                {
                                    label: 'Certified Advanced Social Work Case Manager',
                                    value: 'certifiedAdvancedCaseManager',
                                },
                                {
                                    label: 'Certified Children, Youth, and Family Social Worker',
                                    value: 'certifiedChildrenAndFamily',
                                },
                                {
                                    label: 'Certified Clinical Alcohol, Tobacco, and Other Drugs Social Worker',
                                    value: 'certifiedClinical',
                                },
                                {
                                    label: 'Certified School Social Work Specialist',
                                    value: 'certifiedScool',
                                },
                                {
                                    label: 'Certified Social Work Case Manager',
                                    value: 'certifiedCaceManager',
                                },
                                {
                                    label: 'Certified Social Worker in Healthcare',
                                    value: 'certifiedHealthcare',
                                },
                            ],
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.datePicker',
                            label: 'Expiration Date',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'National Association of Social Workers Credential',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you are credentialed by the National Association of Social Workers, please provide the following information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'responsive-md',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'credentialType',
                            type: 'form.select',
                            label: 'Credential Type',
                            values: [
                                {
                                    label: 'Academy of Certified Social Workers',
                                    value: 'academy',
                                },
                                {
                                    label: 'Diplomate in Clinical Social Work',
                                    value: 'diplomate',
                                },
                                {
                                    label: 'Qualified Clinical Social Worker',
                                    value: 'qualified',
                                },
                            ],
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.datePicker',
                            label: 'Expiration Date',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'National Commission on Certification of Physician Assistants',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you have the certification, please complete all the fields below.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'licenseNumber',
                            type: 'form.text',
                            label: 'Certification Number',
                        },
                        {
                            key: 'date',
                            type: 'form.date',
                            label: 'Expiration Date',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'National Registry for Emergency Medical Technicians',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you have the certification, please complete all the fields below.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    key: 'isTheNameOnThisSpecialty',
                    type: 'form.radio',
                    label: 'Is the name on this specialty the same as the name you provided in your personal information',
                    style: {
                        inline: true,
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                    validate: {
                        required: false,
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^isTheNameOnThisSpecialty',
                        dataNotEq: 'No',
                    },
                    children: [
                        {
                            key: 'firstName',
                            type: 'form.text',
                            label: 'First Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'middleName',
                            type: 'form.text',
                            label: 'Middle Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                        },
                        {
                            key: 'lastName',
                            type: 'form.text',
                            label: 'Last Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'suffix',
                            type: 'form.text',
                            label: 'Suffix',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'text',
                            type: 'form.text',
                            label: 'National Registry of Emergency Medical Technicians',
                            disabled: true,
                            description: 'Certifying Institution',
                        },
                        {
                            key: 'type',
                            type: 'form.select',
                            label: 'Type',
                            values: [
                                {
                                    label: 'Emergency Medical Responder',
                                    value: 'medicalResponder',
                                },
                                {
                                    label: 'Emergency Medical Technician',
                                    value: 'medicalTechnician',
                                },
                                {
                                    label: 'Paramedic',
                                    value: 'paramedic',
                                },
                                {
                                    label: 'Advanced EMT',
                                    value: 'advancedEMT',
                                },
                            ],
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'licenseNumber',
                            type: 'form.text',
                            label: 'Certification Number',
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.date',
                            label: 'Expiration Date:',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Occupation Information',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.panel',
                    style: {
                        layout: 'responsive-md',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'companyName',
                            type: 'form.text',
                            label: 'Company Name',
                        },
                        {
                            key: 'yourTitlePosition',
                            type: 'form.text',
                            label: 'Your Title/Position',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'responsive-md',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'supervisorName',
                            type: 'form.text',
                            label: 'Supervisor Name',
                        },
                        {
                            key: 'supervisorNumber',
                            type: 'form.phone',
                            label: 'Supervisor Number',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'responsive-md',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'addressLine1',
                            type: 'form.text',
                            label: 'Address Line 1',
                            rules: ['validateAccountCompletion'],
                            validate: {
                                required: false,
                            },
                            emptyAsNull: false,
                        },
                        {
                            key: 'addressLine2',
                            type: 'form.text',
                            label: 'Address Line 2',
                            emptyAsNull: true,
                        },
                        {
                            key: 'city',
                            type: 'form.text',
                            label: 'City',
                            rules: ['validateAccountCompletion'],
                            validate: {
                                required: false,
                            },
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    children: [
                        {
                            key: '!postalCodeAndState',
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    key: 'postalCode',
                                    type: 'form.text',
                                    label: 'ZIP Code',
                                    rules: ['validateAccountCompletion'],
                                    validate: {
                                        required: false,
                                    },
                                },
                                {
                                    key: 'state',
                                    type: 'form.select',
                                    label: 'State',
                                    rules: ['validateAccountCompletion'],
                                    disabled: false,
                                    validate: {
                                        required: false,
                                    },
                                    valueProvider: {
                                        type: 'classifier.state',
                                    },
                                },
                            ],
                        },
                        {
                            key: 'residenceType',
                            type: 'form.radio',
                            label: 'County or Tribe of Residence',
                            rules: ['validateAccountCompletion'],
                            style: {
                                inline: true,
                            },
                            values: [
                                {
                                    label: 'County',
                                    value: 'county',
                                },
                                {
                                    label: 'Tribe',
                                    value: 'tribe',
                                },
                            ],
                            validate: {
                                required: false,
                            },
                            description: 'If you are a tribal member, a tribal designee, or currently employed by a tribal government, please enter a Tribe of Residence',
                            defaultValue: 'county',
                        },
                        {
                            key: 'county',
                            type: 'form.select',
                            label: 'County',
                            hidden: {
                                when: '^residenceType',
                                dataNotEq: 'county',
                            },
                            validate: {
                                required: false,
                            },
                            valueProvider: {
                                type: 'classifier.county',
                                paramsFrom: '^!postalCodeAndState/state',
                            },
                            clearDataOnHide: true,
                        },
                        {
                            key: 'tribeId',
                            type: 'form.select',
                            label: 'Tribe',
                            hidden: {
                                when: '^residenceType',
                                dataNotEq: 'tribe',
                            },
                            validate: {
                                required: false,
                            },
                            valueProvider: {
                                type: 'classifier.tribe',
                            },
                            clearDataOnHide: true,
                        },
                    ],
                },
            ],
        },
    },
    {
        name: oigBoardName,
        status: 'active',
    },
    {
        name: 'Pharmacy Specialty',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you possess a specialty from a licensing board, provide the relevant information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    key: 'sameNameAsPersonal',
                    type: 'form.radio',
                    label: 'Is the name on this specialty the same as the name you provided in your personal information',
                    style: {
                        inline: true,
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                    validate: {
                        required: false,
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'responsive-md',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^sameNameAsPersonal',
                        dataNotEq: 'No',
                    },
                    children: [
                        {
                            key: 'firstName',
                            type: 'form.text',
                            label: 'First Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'middleName',
                            type: 'form.text',
                            label: 'Middle Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                        },
                        {
                            key: 'lastName',
                            type: 'form.text',
                            label: 'Last Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'suffix',
                            type: 'form.text',
                            label: 'Suffix',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'responsive-md',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'specialty',
                            type: 'form.select',
                            label: 'Specialty',
                            valueProvider: {
                                type: 'classifier.pharmacySpecialty',
                            },
                        },
                        {
                            key: 'awardingOrganization',
                            type: 'form.text',
                            label: 'Awarding Organization',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'responsive-md',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'licenseNumber',
                            type: 'form.text',
                            label: 'Certification Number',
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.datePicker',
                            label: 'Expiration Date',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Physician and Surgeon Professional License',
        status: 'retired',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.panel',
                    hidden: {
                        custom: hideIfProfessionalStatusTypeIsNotLicensed,
                    },
                    children: [
                        {
                            key: 'content',
                            text: 'Enter the number listed on your license exactly as it appears on your license. If you have additional licenses for different occupations, please add a new occupation to your profile and enter the license number there.',
                            type: 'form.content',
                            style: {
                                alert: 'info',
                            },
                        },
                        {
                            key: 'radio',
                            type: 'form.radio',
                            label: 'Is the name on this license the same as the name you provided in your personal information:',
                            style: {
                                inline: true,
                            },
                            values: [
                                {
                                    label: 'Yes',
                                    value: 'Yes',
                                },
                                {
                                    label: 'No',
                                    value: 'No',
                                },
                            ],
                            validate: {
                                required: false,
                            },
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            children: [
                                {
                                    key: 'firstName',
                                    type: 'form.text',
                                    label: 'First Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    key: 'middleName',
                                    type: 'form.text',
                                    label: 'Middle Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                },
                                {
                                    key: 'lastName',
                                    type: 'form.text',
                                    label: 'Last Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                    validate: {
                                        required: true,
                                    },
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    key: 'licenseType',
                                    type: 'form.select',
                                    label: 'License Type',
                                    values: [
                                        {
                                            label: 'Allopathic',
                                            value: 'allophatic',
                                        },
                                        {
                                            label: 'Osteopathic',
                                            value: 'osteophatic',
                                        },
                                    ],
                                },
                                {
                                    key: 'issuingStateOrJurisdiction',
                                    type: 'form.select',
                                    label: 'Issuing State or Jurisdiction:',
                                    description: 'State or jurisdiction in which this license was issued.',
                                    valueProvider: {
                                        type: 'classifier.state',
                                    },
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    key: 'licenseNumber',
                                    type: 'form.text',
                                    label: 'License Number',
                                    description: 'Professional License number, exactly as it appears on the license.',
                                },
                                {
                                    key: 'expirationDate',
                                    type: 'form.date',
                                    label: 'Expiration Date:',
                                    format: 'mm/dd/yyyy',
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    key: 'isYourLicenseInGoodStanding',
                                    type: 'form.radio',
                                    label: 'Is your license in good standing:',
                                    style: {
                                        inline: true,
                                    },
                                    values: [
                                        {
                                            label: 'Yes',
                                            value: 'Yes',
                                        },
                                        {
                                            label: 'No',
                                            value: 'No',
                                        },
                                    ],
                                },
                                {
                                    key: 'isYourLicenseFreeOfAdverseActionsAndRestrictions',
                                    type: 'form.radio',
                                    label: 'Is your license free of adverse actions and restrictions:',
                                    style: {
                                        inline: true,
                                    },
                                    values: [
                                        {
                                            label: 'Yes',
                                            value: 'Yes',
                                        },
                                        {
                                            label: 'No',
                                            value: 'No',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Physician Assistant Specialty Experience',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.content',
                    key: 'content',
                    text: 'If you have gained a specialty through working experience, indicate it below.',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            type: 'form.select',
                            key: 'physicianAssistantExperience',
                            label: 'Physician Assistant Experience',
                            valueProvider: {
                                type: 'classifier.physicianAssistantExperience',
                            },
                        },
                        {
                            type: 'form.number',
                            key: 'yearsOfSpecialtyExperience',
                            label: 'Years of specialty experience',
                        },
                        {
                            type: 'form.text',
                            key: 'describeYourAreaOfSpecialty',
                            rows: 3,
                            label: 'Describe your area of Specialty',
                            hidden: {
                                custom: functionBodyToString((handler) => {
                                    var _a;
                                    return !((_a = handler
                                        .up()
                                        .down('physicianAssistantExperience')) === null || _a === void 0 ? void 0 : _a.getLabelValueAsTextPairs().some((pair) => pair.label === 'Physician Assistant Experience' && pair.text === 'Other'));
                                }, 'handler'),
                            },
                            clearDataOnHide: true,
                            multiline: true,
                            includeWhiteSpace: false,
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Place of Practice',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.content',
                    key: 'content',
                    text: 'If you are still employed as either a student or an intern, full time, or volunteer, please provide your most recent work experience.',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.select',
                    key: 'select_practice',
                    label: 'Your place of practice is:',
                    values: [
                        {
                            label: 'Clinic',
                            value: 'Clinic',
                        },
                        {
                            label: 'Hospital',
                            value: 'Hospital',
                        },
                        {
                            label: 'Other',
                            value: 'Other',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    key: 'hospitalInformation',
                    label: 'Hospital information',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^select_practice',
                        dataNotEq: 'Hospital',
                    },
                    children: [
                        {
                            type: 'form.select',
                            key: 'hospitalName',
                            label: 'Hospital Name:',
                            hidden: {
                                when: '^select_practice',
                                dataNotEq: 'Hospital',
                            },
                            valueProvider: {
                                type: 'classifier.hospital',
                            },
                        },
                        {
                            type: 'form.text',
                            key: 'hospitalSpecialty',
                            label: 'Hospital Specialty:',
                            hidden: {
                                when: '^select_practice',
                                dataNotEq: 'Hospital',
                            },
                            description: 'Pediatric, Oncology, Rehabilitation',
                        },
                        {
                            type: 'form.date',
                            key: 'lastDateOfPracticeHospital',
                            label: 'Last Date of Practice',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                    clearDataOnHide: true,
                },
                {
                    type: 'form.panel',
                    key: 'clinicInformation',
                    label: 'Clinic information',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^select_practice',
                        dataNotEq: 'Clinic',
                    },
                    children: [
                        {
                            type: 'form.text',
                            key: 'nameOfClinic',
                            label: 'Name of Clinic:',
                            hidden: {
                                when: '^select_practice',
                                dataNotEq: 'Clinic',
                            },
                        },
                        {
                            type: 'form.text',
                            key: 'clinicDescription',
                            label: 'Clinic Description:',
                            hidden: {
                                when: '^select_practice',
                                dataNotEq: 'Clinic',
                            },
                            description: 'Describe the type of health services offered at the facility.',
                        },
                        {
                            type: 'form.date',
                            key: 'lastDateOfPracticeClinic',
                            label: 'Last Date of Practice',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                    clearDataOnHide: true,
                },
                {
                    type: 'form.panel',
                    key: 'facilityInformation',
                    label: 'Facility information',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^select_practice',
                        dataNotEq: 'Other',
                    },
                    children: [
                        {
                            type: 'form.text',
                            key: 'nameOfFacility',
                            label: 'Name of Facility:',
                            hidden: {
                                when: '^select_practice',
                                dataNotEq: 'Other',
                            },
                        },
                        {
                            type: 'form.text',
                            key: 'facilityDescription',
                            label: 'Facility Description:',
                            hidden: {
                                when: '^select_practice',
                                dataNotEq: 'Other',
                            },
                        },
                        {
                            type: 'form.date',
                            key: 'lastDateOfPracticeOther',
                            label: 'Last Date of Practice',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                    clearDataOnHide: true,
                },
                {
                    type: 'form.radio',
                    key: 'areYouAPrivatePractitioner',
                    label: 'Are you a private practitioner:',
                    style: {
                        inline: true,
                    },
                    hidden: {
                        when: '^select_practice',
                        dataNotEq: 'Clinic',
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                    clearDataOnHide: true,
                },
                {
                    type: 'form.panel',
                    key: 'professionalPeerSInformation',
                    label: "Professional Peer's information",
                    style: {
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^areYouAPrivatePractitioner',
                        dataNotEq: 'Yes',
                    },
                    children: [
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    type: 'form.text',
                                    key: 'professionalPeerSName',
                                    label: "Professional Peer's Name:",
                                    hidden: {
                                        when: '^practitioner_radio',
                                        dataNotEq: 'Yes',
                                    },
                                },
                                {
                                    type: 'form.email',
                                    key: 'professionalPeerSEmail',
                                    label: "Professional Peer's Email:",
                                },
                                {
                                    type: 'form.phone',
                                    key: 'professionalPeerSPhoneNumber',
                                    label: "Professional Peer's Phone Number:",
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    type: 'form.text',
                                    key: 'professionalPeerSCityOfResidence',
                                    label: "Professional Peer's City of Residence:",
                                    hidden: {
                                        when: '^practitioner_radio',
                                        dataNotEq: 'Yes',
                                    },
                                },
                                {
                                    type: 'form.select',
                                    key: 'professionalPeerSStateOfResidence',
                                    label: "Professional Peer's State of Residence:",
                                    hidden: {
                                        when: '^practitioner_radio',
                                        dataNotEq: 'Yes',
                                    },
                                    valueProvider: {
                                        type: 'classifier.state',
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    key: 'placeOfPracticeAddressInformation',
                    label: 'Place of Practice address information',
                    style: {
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^select_practice',
                        dataNotIn: ['Clinic', 'Hospital', 'Other'],
                    },
                    children: [
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    type: 'form.text',
                                    key: 'addressLine1',
                                    label: 'Address Line 1:',
                                },
                                {
                                    type: 'form.text',
                                    key: 'addressLine2',
                                    label: 'Address Line 2:',
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    type: 'form.text',
                                    key: 'city',
                                    label: 'City',
                                },
                                {
                                    type: 'form.select',
                                    key: 'state',
                                    label: 'State:',
                                    valueProvider: {
                                        type: 'classifier.state',
                                    },
                                },
                                {
                                    type: 'form.number',
                                    key: 'zipCode',
                                    label: 'Zip Code:',
                                },
                            ],
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    key: 'experienceInformation',
                    label: 'Experience information',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^select_practice',
                        dataNotIn: ['Clinic', 'Hospital', 'Other'],
                    },
                    children: [
                        {
                            type: 'form.text',
                            key: 'describeYourAreaOfPracticeAtTheFacility',
                            rows: 2,
                            label: 'Describe your area of practice at the facility:',
                            multiline: true,
                        },
                        {
                            type: 'form.number',
                            key: 'overallYearsOfExperienceAtThisPlaceOfPractice',
                            label: 'Overall years of experience at this place of practice:',
                            validate: {
                                max: 50,
                                min: 1,
                            },
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    key: 'supervisorInformation',
                    label: 'Supervisor information',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^select_practice',
                        dataNotIn: ['Clinic', 'Hospital', 'Other'],
                    },
                    children: [
                        {
                            type: 'form.text',
                            key: 'supervisorName',
                            label: 'Supervisor Name:',
                        },
                        {
                            type: 'form.email',
                            key: 'supervisorEmail',
                            label: 'Supervisor Email:',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    key: 'employeeInformation',
                    label: 'Employee information',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^select_practice',
                        dataNotIn: ['Clinic', 'Hospital', 'Other'],
                    },
                    children: [
                        {
                            type: 'form.number',
                            key: 'employeeNumber',
                            label: 'Employee Number:',
                            description: 'This number is important to help differentiate you from other employees.',
                        },
                        {
                            type: 'form.number',
                            key: 'medicalStaffOfficeNumber',
                            label: 'Medical Staff Office Number:',
                            description: 'It is important to enter the phone number and extension for your medical staff office. This information will be used to verify your active affiliation and eligibility should you be asked to respond.',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Professional License',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.panel',
                    style: {
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        custom: hideIfProfessionalStatusTypeIsNotLicensed,
                    },
                    children: [
                        {
                            key: 'content',
                            text: 'Enter the number listed on your license exactly as it appears on your license. If you have additional licenses for different occupations, please add a new occupation to your profile and enter the license number there.',
                            type: 'form.content',
                            style: {
                                alert: 'info',
                            },
                        },
                        {
                            key: 'radio',
                            type: 'form.radio',
                            label: 'Is the name on this license the same as the name you provided in your personal information:',
                            style: {
                                inline: true,
                            },
                            values: [
                                {
                                    label: 'Yes',
                                    value: 'Yes',
                                },
                                {
                                    label: 'No',
                                    value: 'No',
                                },
                            ],
                            validate: {
                                required: false,
                            },
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            children: [
                                {
                                    key: 'firstName',
                                    type: 'form.text',
                                    label: 'First Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    key: 'middleName',
                                    type: 'form.text',
                                    label: 'Middle Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                },
                                {
                                    key: 'lastName',
                                    type: 'form.text',
                                    label: 'Last Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                    validate: {
                                        required: true,
                                    },
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    key: 'issuingStateOrJurisdiction',
                                    type: 'form.select',
                                    label: 'Issuing State or Jurisdiction:',
                                    description: 'State or jurisdiction in which this license was issued.',
                                    valueProvider: {
                                        type: 'classifier.state',
                                    },
                                },
                                {
                                    key: 'licenseNumber',
                                    type: 'form.text',
                                    label: 'License Number',
                                    description: 'Professional License number, exactly as it appears on the license.',
                                },
                                {
                                    key: 'expirationDate',
                                    type: 'form.date',
                                    label: 'Expiration Date:',
                                    format: 'mm/dd/yyyy',
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'row',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    key: 'isYourLicenseInGoodStanding',
                                    type: 'form.radio',
                                    label: 'Is your license in good standing:',
                                    style: {
                                        inline: true,
                                    },
                                    values: [
                                        {
                                            label: 'Yes',
                                            value: 'Yes',
                                        },
                                        {
                                            label: 'No',
                                            value: 'No',
                                        },
                                    ],
                                },
                                {
                                    key: 'isYourLicenseFreeOfAdverseActionsAndRestrictions',
                                    type: 'form.radio',
                                    label: 'Is your license free of adverse actions and restrictions:',
                                    style: {
                                        inline: true,
                                    },
                                    values: [
                                        {
                                            label: 'Yes',
                                            value: 'Yes',
                                        },
                                        {
                                            label: 'No',
                                            value: 'No',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                    clearDataOnHide: true,
                },
            ],
        },
    },
    {
        name: 'Radiologic Technologist/Technician Specialty',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you possess a specialty from a licensing board, provide the relevant information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    key: 'isTheNameOnThisSpecialty',
                    type: 'form.radio',
                    label: 'Is the name on this specialty the same as the name you provided in your personal information',
                    style: {
                        inline: true,
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                    validate: {
                        required: false,
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^isTheNameOnThisSpecialty',
                        dataNotEq: 'No',
                    },
                    children: [
                        {
                            key: 'firstName',
                            type: 'form.text',
                            label: 'First Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'middleName',
                            type: 'form.text',
                            label: 'Middle Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                        },
                        {
                            key: 'lastName',
                            type: 'form.text',
                            label: 'Last Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'suffix',
                            type: 'form.text',
                            label: 'Suffix',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'specialty',
                            type: 'form.select',
                            label: 'Specialty',
                            valueProvider: {
                                type: 'classifier.radiologicSpecialty',
                            },
                        },
                        {
                            key: 'licenseNumber',
                            type: 'form.text',
                            label: 'Certification Number',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'awardingOrganization',
                            type: 'form.text',
                            label: 'Awarding Organization',
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.date',
                            label: 'Expiration Date:',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Rank',
        status: 'deprecated',
    },
    {
        name: 'State License',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.panel',
                    style: {
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'content',
                            text: 'Enter the number listed on your license exactly as it appears on your license. If you have additional licenses for different occupations, please add a new occupation to your profile and enter the license number there.',
                            type: 'form.content',
                            style: {
                                alert: 'info',
                            },
                        },
                        {
                            key: 'sameNameAsPersonal',
                            type: 'form.radio',
                            label: 'Is the name on this license the same as the name you provided in your personal information:',
                            style: {
                                inline: true,
                            },
                            values: [
                                {
                                    label: 'Yes',
                                    value: 'Yes',
                                },
                                {
                                    label: 'No',
                                    value: 'No',
                                },
                            ],
                            validate: {
                                required: false,
                            },
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'responsive-md',
                                horizontalAlign: 'left',
                            },
                            hidden: {
                                when: '^sameNameAsPersonal',
                                dataNotEq: 'No',
                            },
                            children: [
                                {
                                    key: 'firstName',
                                    type: 'form.text',
                                    label: 'First Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    key: 'middleName',
                                    type: 'form.text',
                                    label: 'Middle Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                },
                                {
                                    key: 'lastName',
                                    type: 'form.text',
                                    label: 'Last Name:',
                                    hidden: {
                                        when: '^radio',
                                        dataNotEq: 'No',
                                    },
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    key: 'suffix',
                                    type: 'form.text',
                                    label: 'Suffix:',
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'responsive-md',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    key: 'issuingStateOrJurisdiction',
                                    type: 'form.select',
                                    label: 'Issuing State or Jurisdiction:',
                                    description: 'State or jurisdiction in which this license was issued.',
                                    valueProvider: {
                                        type: 'classifier.state',
                                    },
                                },
                                {
                                    key: 'licenseNumber',
                                    type: 'form.text',
                                    label: 'License Number',
                                    description: 'Professional License number, exactly as it appears on the license.',
                                },
                                {
                                    type: 'form.select',
                                    key: 'professionalLicenseType',
                                    label: 'License Type',
                                    values: [
                                        {
                                            label: 'Allopathic',
                                            value: 'Allopathic',
                                        },
                                        {
                                            label: 'Osteopathic',
                                            value: 'Osteopathic',
                                        },
                                    ],
                                    description: 'This field is for the specific Medical License Type under which you practice and is only required for occupations that require Medical School training.',
                                },
                                {
                                    key: 'expirationDate',
                                    type: 'form.datePicker',
                                    label: 'Expiration Date',
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'responsive-md',
                                horizontalAlign: 'left',
                            },
                            children: [
                                {
                                    key: 'licenseInGoodStanding',
                                    type: 'form.radio',
                                    label: 'Is your license in good standing:',
                                    style: {
                                        inline: true,
                                    },
                                    values: [
                                        {
                                            label: 'Yes',
                                            value: 'Yes',
                                        },
                                        {
                                            label: 'No',
                                            value: 'No',
                                        },
                                    ],
                                },
                                {
                                    key: 'licenseFreeOfAdverseActions',
                                    type: 'form.radio',
                                    label: 'Is your license free of adverse actions and restrictions:',
                                    style: {
                                        inline: true,
                                    },
                                    values: [
                                        {
                                            label: 'Yes',
                                            value: 'Yes',
                                        },
                                        {
                                            label: 'No',
                                            value: 'No',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                    clearDataOnHide: true,
                },
            ],
        },
    },
    {
        name: 'Veterinarian Specialty',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'If you possess a specialty from a licensing board, provide the relevant information.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    key: 'isTheNameOnThisSpecialty',
                    type: 'form.radio',
                    label: 'Is the name on this specialty the same as the name you provided in your personal information',
                    style: {
                        inline: true,
                    },
                    values: [
                        {
                            label: 'Yes',
                            value: 'Yes',
                        },
                        {
                            label: 'No',
                            value: 'No',
                        },
                    ],
                    validate: {
                        required: false,
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^isTheNameOnThisSpecialty',
                        dataNotEq: 'No',
                    },
                    children: [
                        {
                            key: 'firstName',
                            type: 'form.text',
                            label: 'First Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'middleName',
                            type: 'form.text',
                            label: 'Middle Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                        },
                        {
                            key: 'lastName',
                            type: 'form.text',
                            label: 'Last Name:',
                            hidden: {
                                when: '^radio',
                                dataNotEq: 'No',
                            },
                            validate: {
                                required: true,
                            },
                        },
                        {
                            key: 'suffix',
                            type: 'form.text',
                            label: 'Suffix',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'specialty',
                            type: 'form.select',
                            label: 'Specialty',
                            valueProvider: {
                                type: 'classifier.veterinarianSpecialty',
                            },
                        },
                        {
                            key: 'licenseNumber',
                            type: 'form.text',
                            label: 'Certification Number',
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            key: 'awardingOrganization',
                            type: 'form.text',
                            label: 'Awarding Organization',
                        },
                        {
                            key: 'expirationDate',
                            type: 'form.date',
                            label: 'Expiration Date:',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Veterinarian Technician Specialty',
        status: 'active',
        form: {
            type: 'form',
            children: [
                {
                    type: 'form.content',
                    key: 'content',
                    text: 'If you possess a specialty from a licensing board, provide the relevant information.',
                    style: {
                        alert: 'info',
                    },
                },
                {
                    type: 'form.yesNo',
                    key: 'isTheNameOnThisSpecialtyVtS',
                    label: 'Is the name on this specialty the same as the name you provided in your personal information',
                    style: {
                        inline: true,
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    hidden: {
                        when: '^isTheNameOnThisSpecialtyVtS',
                        dataNotEq: false,
                    },
                    children: [
                        {
                            type: 'form.text',
                            key: 'firstNameVtS',
                            label: 'First Name:',
                            validate: {
                                required: true,
                            },
                            includeWhiteSpace: false,
                        },
                        {
                            type: 'form.text',
                            key: 'middleNameVtS',
                            label: 'Middle Name:',
                            includeWhiteSpace: false,
                        },
                        {
                            type: 'form.text',
                            key: 'lastNameVtS',
                            label: 'Last Name:',
                            validate: {
                                required: true,
                            },
                            includeWhiteSpace: false,
                        },
                        {
                            type: 'form.text',
                            key: 'suffixVtS',
                            label: 'Suffix',
                            includeWhiteSpace: false,
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            type: 'form.select',
                            key: 'specialtyVtS',
                            label: 'Specialty',
                            valueProvider: {
                                type: 'classifier.veterinarianTechSpecialty',
                            },
                        },
                        {
                            type: 'form.text',
                            key: 'licenseNumberVtS',
                            label: 'Certification Number',
                            includeWhiteSpace: false,
                        },
                    ],
                },
                {
                    type: 'form.panel',
                    style: {
                        layout: 'row',
                        horizontalAlign: 'left',
                    },
                    children: [
                        {
                            type: 'form.text',
                            key: 'awardingOrganizationVtS',
                            label: 'Awarding Organization',
                            includeWhiteSpace: false,
                        },
                        {
                            type: 'form.date',
                            key: 'expirationDateVtS',
                            label: 'Expiration Date:',
                            format: 'mm/dd/yyyy',
                        },
                    ],
                },
            ],
        },
    },
    {
        name: 'Work ID',
        status: 'retired',
    },
];
